import React, {Component} from 'react';
import { Router, Route, browserHistory } from 'react-router';
import {Helmet} from "react-helmet";
import BeginReferencing from './components/Screens/BeginReferencing';
import StartScreen from './components/Screens/StartScreen';
import BeginApplication from './components/Screens/BeginApplication';
import Declaration from './components/Screens/Declaration';
import TenantsDetails from './components/Screens/TenantsDetails';
import ResidenceDetails from './components/Screens/ResidenceDetails';
import EmploymentDetails from './components/Screens/EmploymentDetails';
import AdditionalDetails from './components/Screens/AdditionalDetails';
import Summary from './components/Screens/Summary';
import ApplicationSubmitted from './components/Screens/ApplicationSubmitted';
import AddTenant from './components/Screens/AddTenant';
import CaseSummary from './components/Screens/CaseSummary';
import AddFinancialReferee from './components/Screens/AddFinancialReferee';
import EditLettingReferee from './components/Screens/EditLettingReferee';
import ErrorScreen from './components/Screens/Error';
import ErrorApplicationSubmittedScreen from './components/Screens/ErrorApplicationSubmittedScreen';
import CaseComplete from './components/Screens/CaseComplete';
import ApplicantSubmitted from './components/Screens/ApplicantSubmitted';
import AddGuarantor from './components/Screens/AddGuarantor';
import SiteFooter from './components/Fragments/SiteFooter';
import ReferenceRequest from './components/Screens/ReferenceRequest/Index';
import ReferencingRequestComplete from './components/Screens/ReferenceRequest/Complete';

let HttpService = require('./components/Managers/HttpService');
let title;
let theme;
let envConfig;

export default class App extends Component {
    constructor(props) {
        super(props);
        envConfig = HttpService.getConfigForHost();
        title = envConfig.configBrand;
        theme = envConfig.theme;
    }

    componentWillMount() {
        // todo: this will break if we add another brand, but I cannot find any other way to load separate css from the same host (with only different DNS)
        if (document.styleSheets[2]) {
            // First disable the third stylsheet in the array - i.e. rentshield in this context
            document.styleSheets[2].disabled = true;

            // Re-enable it ONLY if we're using that theme
            if ('rentshield' === theme) {
                document.styleSheets[2].disabled = false;
            }
        } else {
            // Only load in the non-compiled styles if we're in dev
            require('./styles/themes/' + envConfig.theme + '/theme.scss');
        }

        // Dynamically load in the logo source based on the theme - this bit is fine
        document.getElementById('logo-big').src = ('/images/logo-' + theme + '.svg');
        document.getElementById('logo-small').src = ('/images/logo-' + theme + '-small.svg');
    }

    render() {
        return(
            <div>
                <Helmet>
                    <title>{title}</title>
                    <link rel="shortcut icon" type="image/x-icon" href={'/' + theme + '-favicon.ico'}/>
                </Helmet>
                <Router
                    history={browserHistory}
                >
                    <Route path="/begin-application(/:linkref)" component={BeginApplication} />

                    <Route path="referee-request/:type/:linkref" component={ReferenceRequest} />
                    <Route path="referee-request/submitted" component={ReferencingRequestComplete} />

                    <Route path="application">
                        <Route path="declaration" component={Declaration} />
                        <Route path="your-details" component={TenantsDetails} />
                        <Route path="your-landlord" component={ResidenceDetails} />
                        <Route path="your-finances" component={EmploymentDetails} />
                        <Route path="additional-details" component={AdditionalDetails} />
                        <Route path="summary(:/linkref)" component={Summary} />
                        <Route path="submitted" component={ApplicationSubmitted} />

                        <Route path="financial-referee">
                            <Route path="add/:number/:tokenId" component={AddFinancialReferee} />
                            <Route path="edit/:existingNumber/:tokenId" component={AddFinancialReferee} />
                        </Route>

                        <Route path="letting-referee">
                            <Route path="edit/:tokenId" component={EditLettingReferee} />
                        </Route>
                    </Route>

                    <Route path="case">
                        <Route path="begin" component={StartScreen} />
                        <Route path="add-another-tenant/:number" component={AddTenant} />
                        <Route path="add-guarantor/:applicationId/:hash" component={AddGuarantor} />
                        <Route path="add-tenant/:caseId/:hash" component={AddTenant} />
                        <Route path="summary" component={CaseSummary} />
                        <Route path="submitted" component={CaseComplete} />
                        <Route path="applicant-submitted" component={ApplicantSubmitted} />
                    </Route>

                    <Route path="/error/application-submitted" component={ErrorApplicationSubmittedScreen} />
                    <Route path="/error(/:type)" component={ErrorScreen} />
                    <Route path="/(:hash)" component={BeginReferencing} />
                </Router>
                <SiteFooter version={'50.10.20191204'} isDynamic={true} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js